import * as React from "react";
import PropTypes from "prop-types";

import { FormControl } from "kanopi-components/Input";
import { CardSelect as Input } from "kanopi-components/CardSelect";

export function CardSelect({ label, title, help, showLabel, error, ...props }) {
  return (
    <FormControl
      label={label}
      title={title}
      caption={help}
      hideLabel={!showLabel}
      forceFocus
      error={error}
      initialLoad={props.initialLoad}
      overrides={{
        Label: {
          style: ({ $theme }) => ({
            ...$theme.typography.LabelMedium,
            textAlign: "center",
            [`@media screen and (max-width: ${$theme.breakpoints.medium}px)`]: {
              textAlign: "left",
            },
          }),
        },
      }}
    >
      <Input {...props} />
    </FormControl>
  );
}

CardSelect.propTypes = {
  label: PropTypes.string,
  title: PropTypes.string,
  help: PropTypes.string,
  showLabel: PropTypes.bool,
  error: PropTypes.any,
  props: PropTypes.any,
  initialLoad: PropTypes.bool,
};
